<nb-layout>
    <nb-layout-column>
        <ng-container *ngIf="userData;  else loggedOut">
            <div class="efs-login">

                <img src="https://files.efs-ag.services/EFS-Logo_weiss.png" alt="EFS Logo" class="mb-5" height="50px">

                <p class="mb-3">Sie sind eingeloggt als<br><em><b>{{ userData.name }}</b> ({{ userData.nickname }})</em>.</p>

                <p class="mb-4">Eventuell haben Sie nicht die erforderlichen Rechte, um auf das Admin Panel zuzugreifen.</p>

                <button nbButton size="small" status="danger" (click)="logout()">Logout</button>
            </div>
        </ng-container>

        <ng-template #loggedOut>
            <div class="efs-login">

                <img src="https://files.efs-ag.services/EFS-Logo_weiss.png" alt="EFS Logo" class="mb-5" height="50px">

                <div class="id_token_expired_alert">
                    <nb-alert accent="warning" class="big-alert">
                        <div class="row">
                            <div class="col-2">
                                <nb-icon nbSuffix icon="alert-triangle-outline" pack="eva" status="control"></nb-icon>
                            </div>
                            <div class="col-10">
                                Ihre Sitzung ist abgelaufen, bitte melden Sie sich neu an!
                            </div>
                        </div>
                    </nb-alert>
                </div>
                <h1>EFS Adminpanel</h1>
                <p>Bitte melden Sie sich mit Ihrem Benutzerkonto an.</p>
                <button nbButton size="small" status="primary" (click)="login()">Login via EFS</button>
            </div>
        </ng-template>
    </nb-layout-column>
</nb-layout>